export default "__VITE_ASSET__BcqZqMtK__"